import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, Modal } from 'common/components'

type ConfirmBenefitLaunchModalProps = {
  visible: boolean
  onCancel: () => void
  onSendInvite?: () => void
  isLoading?: boolean
}

const ConfirmBenefitLaunchModal = ({ visible, isLoading, onCancel, onSendInvite }: ConfirmBenefitLaunchModalProps) => {
  const { t: translate } = useTranslation()

  return (
    <Modal
      onCancel={onCancel}
      visible={visible}
      title={'Launch Your Benefit'}
      footer={
        <div>
          <Button onClick={onCancel}>{translate('general.cancel')}</Button>

          <Button onClick={onSendInvite} type="primary" loading={isLoading} className="ml-8">
            Confirm
          </Button>
        </div>
      }
    >
      <div>
        Click Confirm to lock-in your ICHRA Notification & Benefits Start Dates. Once set, these dates cannot be
        changed. PeopleKeep will automatically process and send your ICHRA Notification and PeopleKeep Welcome emails on
        the selected date.
      </div>
    </Modal>
  )
}

export default ConfirmBenefitLaunchModal
